module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-139.47371b5a.svg";